'use client'

import { Form, InputGroup, Button } from 'react-bootstrap'
import Link from 'next/link'
import { useState, useRef } from 'react'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { TOAST_ERROR } from '@/shared/constants/toastTypes.js'

export const FormAuth = ({ textButton, submitForm }) => {
    const [checked, setChecked] = useState(false)
    const [showPassword, setShowPassword] = useState(false)

    const emailRef = useRef('')

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword)
    }

    const validateEmail = (value) => {
        if (value.trim() !== value) {
            TOAST_ERROR('Email не должен начинаться или заканчиваться пробелом');
            return false;
        }
        // базовая email-проверка
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
            TOAST_ERROR('Email не корректен');
            return false;
        }

        return true;
    };

    const handleSumbit = (e) => {
        e.preventDefault()

        const emailValue = emailRef.current;
        console.log(emailRef.current)
        if (!validateEmail(emailValue)) return;

        submitForm(e, checked)
    }

    // const handleSubmit = (e) => {
    //     submitForm(e, checked)
    // }

    return (
        <form className={'FormAuth'} onSubmit={handleSumbit}>
            <InputGroup className={'input-control'}>
                <label>E-Mail</label>
                <Form.Control
                    required={true}
                    type={'text'}
                    placeholder={'Введите E-Mail'}
                    name={'email'}
                    onChange={(e) => {
                        emailRef.current = e.target.value
                    }}
                />
            </InputGroup>
            <InputGroup className={'input-control input-control-password'}>
                <label>Пароль</label>
                <Form.Control
                    required={true}
                    type={showPassword ? 'text' : 'password'}
                    placeholder={'Введите пароль'}
                    name={'password'}
                    style={{ paddingRight: '40px' }}
                />
                <Button
                    className="show-password"
                    variant="link"
                    onClick={togglePasswordVisibility}
                >
                    {showPassword ? (
                        <FaEye size={40} color="black" />
                    ) : (
                        <FaEyeSlash size={40} color="black" />
                    )}
                </Button>
            </InputGroup>
            <div className={'actions'}>
                <InputGroup className={'remember-device'}>
                    <Form.Check
                        onChange={() => setChecked((state) => !state)}
                    />
                    <span>Запомнить устройство</span>
                </InputGroup>
                <Link href={'/recovery'}>Забыли пароль</Link>
            </div>
            <button type={'submit'}>{textButton}</button>
        </form>
    )
}
